module.exports = __webpack_public_path__ + "img/speakers.850d44d4.svg";